import React, { useState, useContext } from 'react'
import classNames from 'classnames'
import { TicketsAppContext } from '../context/tickets-app-context'
import { Tickets, PartyOptIn } from '../components'
import {
  noTickets,
  includesAdult,
  includesGeneric,
  optInParty,
  hasMemberTickets,
  inManualUpdate,
  isStandalone,
  hasPriceTypes
} from '../helpers/logic'

function AddOnParty({ close }) {
  const [partyOptedIn, setPartyOptedIn] = useState(true)
  const {
    actions: { addItemsToCart },
    chosenEvent,
    chosenAddOn,
    cart
  } = useContext(TicketsAppContext)

  let cantContinue = true
  let genericAgeGroupIssue = false
  let basEventHasGenericTicketsSelected = includesGeneric(chosenEvent.tickets)

  if (chosenAddOn) {
    const {
      tickets,
      pricing: { nonMember }
    } = chosenAddOn
    const optedIntoAddOnOnly = partyOptedIn && chosenAddOn.addOnOnly
    const doesNotIncludeAdultOrGeneric =
      noTickets(tickets) ||
      (!includesAdult(tickets) && !includesGeneric(tickets))

    cantContinue = doesNotIncludeAdultOrGeneric
    if (inManualUpdate) {
      cantContinue = optedIntoAddOnOnly
        ? cantContinue
        : cantContinue || !hasMemberTickets(tickets)
    }

    const priceTypesChosenAddOn = Object.keys(nonMember)
    let isAddOnSingleGeneric =
      priceTypesChosenAddOn.length == 1 &&
      priceTypesChosenAddOn.every(type => type.includes('generic'))
    let isAddOnMultiGenericOrMixed =
      priceTypesChosenAddOn.length > 1 &&
      priceTypesChosenAddOn.some(type => type.includes('generic'))

    genericAgeGroupIssue =
      (basEventHasGenericTicketsSelected && !isAddOnSingleGeneric) ||
      isAddOnMultiGenericOrMixed
  }

  const onAddToCart = async () => {
    let eventToAdd = chosenAddOn
    if (eventToAdd.addOnOnly && !genericAgeGroupIssue && partyOptedIn) {
      if (isStandalone(chosenEvent)) {
        eventToAdd = optInParty(chosenEvent, chosenAddOn)
      } else {
        eventToAdd = optInParty(chosenAddOn)
      }
    }
    await addItemsToCart([eventToAdd])
    close()
  }
  const illinoisFreeDay = hasPriceTypes(['illinois'], chosenEvent)
  const onToggleOptIn = _ => {
    setPartyOptedIn(!partyOptedIn)
  }

  let shouldShowAddAllCheckBox =
    partyOptedIn && chosenAddOn.addOnOnly && !genericAgeGroupIssue

  return (
    <React.Fragment>
      {shouldShowAddAllCheckBox ? (
        <PartyOptIn
          onToggle={onToggleOptIn}
          optedIn={partyOptedIn}
          eventName={chosenAddOn.name}
        />
      ) : (
        <Tickets
          cartItem={chosenAddOn}
          illinois={illinoisFreeDay}
          showEventHeading={false}
        />
      )}
      <button
        data-testid={'add-on-party-dialog-add-to-cart'}
        type="button"
        className={classNames('mt-20 button -big', {
          '-disabled': shouldShowAddAllCheckBox ? false : cantContinue
        })}
        onClick={onAddToCart}
        disabled={shouldShowAddAllCheckBox ? false : cantContinue}
      >
        {cart.loading ? 'Loading...' : 'Add to Cart and Continue'}
      </button>
      <button
        className="text-link block pt-20"
        onClick={close}
      >
        Cancel
      </button>
    </React.Fragment>
  )
}

export default AddOnParty
